import Icon from '@material-ui/core/Icon/Icon';
import IconButton from '@material-ui/core/IconButton/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import React, { useState } from 'react';
import styled from 'styled-components';
import FormikField from '../../../../Components/Form/FormikField';
import { Col } from '../../../../Components/Layout/Col';
import { Row } from '../../../../Components/Layout/Row';

const Style = styled(Row)`
    && {
        .column {
            margin-top: 8px;
        }
        .icon-grey {
            color: #757575;
        }
    }
`;

const LoginForm = () => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const getInputAdornment = (icon) => {
        return {
            InputProps: {
                startAdornment: (
                    <InputAdornment position={'start'}>
                        <Icon className={'icon-grey'}>{icon}</Icon>
                    </InputAdornment>
                ),
            },
        };
    };

    return (
        <Style>
            <Col xs={6} className={'column'}>
                <FormikField name={'user.first_name'} label="First Name" textFieldProps={getInputAdornment('person')} />
            </Col>
            <Col xs={6} className={'column'}>
                <FormikField name={'user.last_name'} label="Last Name" />
            </Col>
            <Col xs={12} className={'column'}>
                <FormikField
                    name={'organization_name'}
                    label="Company / Team Name"
                    textFieldProps={getInputAdornment('people')}
                />
            </Col>
            <Col xs={12} className={'column'}>
                <FormikField name={'user.email'} label="E-Mail" textFieldProps={getInputAdornment('email')} />
            </Col>
            <Col xs={12} className={'column'}>
                <FormikField
                    name={'user.password'}
                    label="Create Password"
                    type={showPassword ? 'text' : 'password'}
                    textFieldProps={{
                        InputProps: {
                            startAdornment: (
                                <InputAdornment position={'start'}>
                                    <Icon className={'icon-grey'}>lock</Icon>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={handleClickShowPassword}
                                    >
                                        <Icon className={'icon-grey'}>
                                            {showPassword ? 'visibility' : 'visibility_off'}
                                        </Icon>
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </Col>
        </Style>
    );
};

export default LoginForm;
